import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
  showLabel?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '', showLabel = false }) => {
  const { resolved, toggle } = useTheme();
  const isDark = resolved === 'dark';
  const icon = isDark ? 'fa-sun' : 'fa-moon';
  const title = isDark ? 'Açık temaya geç' : 'Koyu temaya geç';
  const label = isDark ? 'Tema: Açık' : 'Tema: Koyu';

  return (
    <button
      type="button"
      onClick={toggle}
      className={`btn btn-link p-0 d-inline-flex align-items-center ${className}`.trim()}
      aria-label="Temayı değiştir"
      aria-pressed={isDark}
      title={title}
    >
      <i className={`fas ${icon}`} />
      {showLabel && <span className="ms-2">{label}</span>}
    </button>
  );
};

export default ThemeToggle;
